<template>
  <div class="record-container"
       v-loading.fullscreen="fullscreenLoading">
    <div class="title">
      TK账号归属地查询
    </div>
    <div class="intro-code-box">
      <div class="intro">
        TK后勤部目前专注于TikTok服务商领域，主要服务对象为TikTok从业人员，力求以真诚靠谱的服务与产品来满足大家运营过程中的相关需求。
        <br />目前主要提供以下三块服务：<br />
        <strong>
          · 硬件类（如二手工作机／办公电脑/全球海外运营商废卡/运营商专线/软路由等）<br />
          · 软件类（如账号云控／无人直播系统/店群ERP/达人邀约软件等）<br />
          · 资源信息类（小店售卖和代开／小店补单/刷粉刷赞/官方机构代开/店铺报白/金币充值等）<br />
        </strong><br />
        业务对接可联系右边二维码👉🏻
      </div>
      <div class="code">
        <img src="../../assets/down-code.png"
             alt="">
      </div>
    </div>
    <div class="input-tool-box">
      <div class="input-box">
        <input type="text"
               v-model="userId"
               placeholder="请输入用户ID">
        <div @click="getLocation"
             class="btn">
          查询
        </div>
      </div>
      <div class="tip">
        *查询结果来源于互联网公开信息，可能存在误差，仅供参考</div>
    </div>
    <div class="get-url"
         v-if="downloadUrl">
      该账号归属地为: {{ downloadUrl }}
    </div>
    <div class="teach-box">
      <div class="teach-title">
        使用教程:
      </div>
      <div class="teach-content">
        <div class="teach-text">
          输入@后面的昵称到上方输入框，如legend_hong，即可查询(无视频账号无法查询)
        </div>
        <img class="example"
             src="../../assets/tk-example.png"
             alt="">
      </div>

    </div>
  </div>
</template>

<script>
import { getLocation } from "@/api/home"
import { Message } from 'element-ui'
export default {
  data () {
    return {
      userId: '',
      downloadUrl: '',
      fullscreenLoading: false,
    }
  },
  methods: {
    async getLocation () {

      if (localStorage.getItem('token')) {
        this.fullscreenLoading = true
        const res = await getLocation({ id: this.userId })
        if (res.code == 10000) {
          this.downloadUrl = res.data
          this.fullscreenLoading = false
        } else {
          this.fullscreenLoading = false
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
        }
      } else {
        Message({
          message: '请先登录',
          type: 'error',
          duration: 5 * 1000
        })
      }

    }
  }
}
</script>

<style lang="less" scoped>
.record-container {
  width: 1200px;
  margin: 30px auto 30px;
  padding-left: 20px;
  box-sizing: border-box;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-left: 24px;
  }
  .intro-code-box {
    display: flex;
    margin-top: 20px;
    .intro {
      width: 750px;
      padding: 15px 20px;
      background: #eeeeee;
      border-radius: 5px;
      font-size: 14px;
    }
    .code {
      margin-left: 82px;
      img {
        width: 130px;
        height: 130px;
      }
    }
  }
  .input-tool-box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .input-box {
      width: 400px;
      display: flex;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #3898ff;
      input {
        flex: 1;
        border-radius: 12px 0 0 12px;
        padding-left: 20px;
        font-size: 16px;
        border: none;
      }
      .btn {
        padding: 13px 32px;
        background: #3898ff;
        color: #ffffff;
        border-radius: 0px 12px 12px 0px;
        cursor: pointer;
      }
    }
    .tip {
      font-size: 14px;
      color: #999;
      margin-left: 32px;
    }
  }
  .get-url {
    display: inline-block;
    font-size: 16px;
    margin-left: 20px;
    margin-top: 18px;
    font-weight: 600;
    padding: 12px 20px;
    background: #94ebf3;
    border-radius: 5px;
  }
  .teach-box {
    margin-top: 30px;
    .teach-title {
      font-size: 22px;
      font-weight: bold;
    }
    .teach-content {
      margin-top: 10px;
      .teach-text {
        font-size: 20px;
        font-weight: bold;
      }
      .example {
        width: 359px;
        height: 291px;
        margin-top: 20px;
      }
    }
  }
}
</style>